<template>
    <AppMainFormCard :isLoading="isLoading" :tituloTela="tituloTela" :canDelete="isEditing" @delete="beforeDeleteRegistro" :canAdd="false"
        :isSearch="true" :canSearch="false">
        <v-form v-model="isFormValid" ref="form">
            <v-layout row justify-center>
                <v-flex class="item" xs12 md11 ma-5>
                    <h3><b>Dados da Origem dos Animais</b></h3>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center>
                <v-flex class="item" xs11 md11 lg11>
                    <v-autocomplete :rules="[campoSelectObrigatorio]" v-model="registro.cdPessoaProdutor" :items="produtores" clearable
                        color="primary" item-text="displayName" item-value="idProdutor" label="Selecione o produtor por CPF ou nome" outlined>
                    </v-autocomplete>
                </v-flex>
            </v-layout>
            <v-layout row justify-center>
                <v-flex class="item" xs12 md11 ma-5>
                    <h3><b>Dados da Saída dos Animais</b></h3>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center>
                <v-flex class="item" xs12 md5>
                    <SelectDate :rules="[campoObrigatorio, validarData]" label="Data" v-model="dataSaida"></SelectDate>
                </v-flex>
                <v-flex class="item" xs12 md5>
                    <SelectHour :rules="[campoObrigatorio, validarHora]" label="Hora" v-model="registro.hrSaida"></SelectHour>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center>
                <v-flex class="item" xs11 md4>
                    <v-text-field v-model.number="qtMachos" label="Qtd. Macho" outlined
                                  v-only-int persistent-hint
                                  :filled="registro.sgSexo === 'FE'" :readonly="registro.sgSexo === 'FE'"
                                  :hint="registro.sgSexo === 'FE' ? 'Gênero dos animais fêmea' : ''"
                                  clearable :rules="[campoMaiorOuIgualZero]">
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs11 md4>
                    <v-text-field  v-model.number="qtFemeas" label="Qtd. Fêmea" persistent-hint
                                   :filled="registro.sgSexo === 'MA'" :disabled="registro.sgSexo === 'MA'"
                                   v-only-int :hint="registro.sgSexo === 'MA' ? 'Gênero dos animais macho' : ''"
                        outlined clearable :rules="[campoMaiorOuIgualZero]">
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs11 md3>
                    <v-text-field  label="Total de Animais" :value="qtdTotalAnimais"
                                   :disabled="qtMachos > 0 || qtFemeas > 0" outlined
                                   :rules="[qtdTotalAnimaisMaiorQueZero]">
                    </v-text-field>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center>
                <v-flex class="item" xs12 md5>
                    <v-text-field :rules="[tamanhoMaximoOito]" v-model.trim="registro.dsPlacaCaminhao" label="Placa do Caminhão" outlined clearable>
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs12 md6>
                    <v-autocomplete :rules="[campoSelectObrigatorio]" v-model="registro.csTipoDestino" :items="listaTipoDestino" clearable
                        color="primary" item-text="dsTipoDestino" item-value="csTipoDestino" label="Destino dos Animais" outlined
                        @change="changeDestino">
                    </v-autocomplete>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center>
                <v-flex class="item" xs12 md11 mb-5>
                    <h3><b>Dados da G.T.A</b></h3>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center>
                <v-flex class="item" xs11 md4 lg4>
                    <v-text-field :rules="[campoObrigatorio, campoMaiorZero]" v-mask="maskGta" v-model.number="registro.nrGta" type="tel" label="Número" 
                        outlined clearable>
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs11 md3 lg3>
                    <v-text-field :rules="[campoObrigatorio]" v-mask="maskSerie" v-model.trim="registro.dsSerieGta" label="Série" 
                        outlined clearable>
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs11 md4 lg4>
                    <SelectDate :rules="[campoObrigatorio, validarData, validarDataFutura]" label="Data"
                                v-model="dataGTA"></SelectDate>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center>
                <v-flex class="item" xs12 md11 mb-5>
                    <h3><b>Dados do Destino</b></h3>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center v-if="destinoAbate">
                <v-flex class="item" xs11 md11 lg11>
                    <v-autocomplete :rules="[campoSelectObrigatorio]" v-model="registro.cdPlantaAbate" :items="plantasAbate" clearable
                        color="primary" item-text="displayName" item-value="idPlantaAbate" 
                        label="Selecione a planta de abate por registro no SIF ou nome" outlined>
                    </v-autocomplete>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center v-else>
                <v-flex class="item" xs11 md11 lg11>
                    <v-autocomplete :rules="[campoSelectObrigatorio]" v-model="registro.cdEstabelecimentoDestino" :items="estabelecimentos" clearable
                        color="primary" item-text="displayName" item-value="idEstabelecimento" 
                        label="Selecione o estabelecimento por código oficial ou nome" outlined>
                    </v-autocomplete>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center v-if="destinoAbate">
                <v-flex class="item" xs11 md5 lg5>
                    <SelectDate :rules="[validarData]" label="Data do Abate"
                                v-model="dataAbate" :error-messages="dataAbateErrors"></SelectDate>
                </v-flex>
                <v-flex xs11 sm11 md6 lg6>
                    <v-spacer/>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center v-else>
                <v-flex class="item" xs11 md11 lg11>
                    <v-autocomplete :rules="[campoSelectObrigatorio]" v-model="registro.cdUnidadeExploracaoDestino" :items="unidadesExploracao" clearable
                        color="primary" item-text="displayName" item-value="idUnidadeExploracao" 
                        label="Selecione a unidade exploração por número ou tipo" outlined>
                    </v-autocomplete>
                </v-flex>
            </v-layout>
        </v-form>
        <v-layout pa-2 pr-8 pl-8>
            <v-flex>
                <AppMainActionsButtonsForm @save="saveRegistro" @return="voltar" :canDelete="false"/>
            </v-flex>
        </v-layout>
    </AppMainFormCard>
</template>

<script>
import { campoObrigatorio, campoSelectObrigatorio, validarData, validarHora, validarDataFutura, campoMaiorZero,
    tamanhoMaximoOito, data1InferiroData2, qtdTotalAnimaisMaiorQueZero, data1DepoisOuIgualDeData2,
  campoMaiorOuIgualZero } from '../../filters/rules'
import { MensagemSuccessSave } from '@/resourceMessageFile.js'
import { uepTypeExpand, dateLocalToIso, dateIsoToLocal, formatCPF, formatCNPJ } from '@/filters/utils'
import { mask } from 'vue-the-mask'
import { validationMixin } from 'vuelidate'
import { requiredIf, required, requiredUnless } from 'vuelidate/lib/validators';

import AppMainFormCard from '@/components/layout/AppMainFormCard.vue'
import AppMainActionsButtonsForm from '@/components/layout/AppMainActionsButtonsForm.vue'
import SelectDate from '@/components/general/SelectDate.vue'
import SelectHour from '@/components/general/SelectHour.vue'

const toProdutoresView = entry => {
    var documento = ''
    if (entry.nrDocumento.length > 11) {
        documento = formatCNPJ(entry.nrDocumento)
    }
    else {
        documento = formatCPF(entry.nrDocumento)
    }
    let displayName = documento + ' | ' + entry.nmProdutor
    return {...entry, displayName}
}

const toUepsView = entry => {
    let displayName = entry.nrUnidadeExploracao + ' - ' + uepTypeExpand(entry.csTipoUnidadeExploracao)
    return {...entry, displayName}
}

const validateContain = (arrayParams, callbackFunction) => { return callbackFunction(...arrayParams) };

export default {
    name: 'SaidaAnimais',
    components: {
        AppMainFormCard,
        AppMainActionsButtonsForm,
        SelectDate,
        SelectHour,
    },
    directives: {
        mask,
    },
    mixins: [validationMixin],
    validations() {
        let regras = { dataAbate: {}, qtAnimais: {}}

        if (this.destinoAbate){
            regras.dataAbate = {
                required,
                dataAbateAntesGta: () => data1DepoisOuIgualDeData2(this.dataAbate, this.dataGTA),
                dataAbateAntesSaida: () => data1DepoisOuIgualDeData2(this.dataAbate, this.dataSaida),
            }
        }
        if (this.qtFemeas + this.qtMachos < 1) {
            regras.qtAnimais = {
                required
            }
        }
        return regras
    },
    data() {
        return{
            isFormValid: false,
            isEditing: false,
            isModified: false,
            registro: {},
            isLoading: false,
            cdLoteProducao: 0,
            dataSaida: '',
            dataAbate: '',
            dataGTA: '',
            unidadesExploracao: [],  
            destinoAbate: false,       
            listaTipoDestino: [
                {
                    csTipoDestino: 'AB',
                    dsTipoDestino: 'Abate'
                },
                {
                    csTipoDestino: 'CR',
                    dsTipoDestino: 'Creche'
                },
                {
                    csTipoDestino: 'TR',
                    dsTipoDestino: 'Terminação'
                },
                {
                    csTipoDestino: 'WF',
                    dsTipoDestino: 'Wean to Finish'
                },
                {
                    csTipoDestino: 'UP',
                    dsTipoDestino: 'UPL'
                }
            ],
            produtores: [],
            maskSerie: 'AA',
            maskGta: '#########',
            qtAnimais: 0,
            qtMachos: 0,
            qtFemeas: 0,
        }
    },
    computed: {
        tituloTela: {
            get() {
                if (this.isEditing)
                    return 'Saída de Animais: ' + this.registro.idSaidaAnimais

                return 'Inserindo nova Saída de Animais'
            }
        },
        estabelecimentos () {
            return this.$store.state.estabelecimentos
        },
        plantasAbate () {
            return this.$store.state.plantasAbate
        },
        urlAPIEstabelecimento() {
            return this.$store.state.urlAPIEstabelecimento
        },
        dataAbateErrors() {
            let errors = [];
            if (!this.$v.dataAbate.$dirty) return errors;
            if (!this.$v.dataAbate.required) errors.push('Campo Obrigatório.');
            if (!this.$v.dataAbate.dataAbateAntesGta)
                errors.push('Data de Abate não pode ser antes da Data da Gta.');
            if (!this.$v.dataAbate.dataAbateAntesSaida)
                errors.push('Data de Abate não pode ser antes da Data de Saída.');
            return errors;
        },
        qtdTotalAnimais: {
            get() {
                if (this.qtMachos > 0 && this.qtFemeas > 0) {
                    return this.qtMachos + this.qtFemeas;
                }
                else if (this.qtMachos > 0) {
                    return this.qtMachos;
                }
                else if (this.qtFemeas > 0) {
                    return this.qtFemeas;
                }
                return this.qtAnimais
            },
            set(value) { this.qtAnimais = value }
        }
    },
    methods: {
        campoObrigatorio,
        campoSelectObrigatorio,
        validarData,
        validarHora,
        validarDataFutura,
        campoMaiorZero,
        dateLocalToIso,
        dateIsoToLocal,
        tamanhoMaximoOito,
        uepTypeExpand,
        formatCPF,
        formatCNPJ,
        data1InferiroData2,
        data1DepoisOuIgualDeData2,
        campoMaiorOuIgualZero,
        qtdTotalAnimaisMaiorQueZero,
        loadLoteProducao (id) {
            this.batch = {}
            var context = this
            this.$axios.get('lote-producao/'+id)
            .then( response => {
                var batch = response.data[0].data

                this.registro.sgSexo = batch.sgSexo

                this.$axios.get(this.urlAPIEstabelecimento + 'produtor/?cdEstabelecimento=' + batch.cdEstabelecimento)
                    .then((response) => {
                        context.produtores = response.data ? response.data.map(toProdutoresView) : []
                    })
                    .catch((error) => {
                        this.changeViewState('isError', error)
                    })
            })
        },
        changeDestino (value) {
            this.destinoAbate = false
            if (value == 'AB')
                this.destinoAbate = true
        },
        changeViewState(status, value) {
            if (status == 'isInserting'){
                this.isLoading = true
                if (this.$refs.form != undefined) 
                {
                    this.$refs.form.reset()
                }
                this.carregarRegistrosLimpos()
                this.isLoading = false
                this.isEditing = false
                this.isModified = false
            } else if (status == 'isEditing'){
                this.isLoading = true
                this.getRegistro(value)
                this.isEditing = true
            } else if (status == 'isError'){
                this.$store.commit('setSnack', {type: 'error', msg : value})
                this.isLoading = false
            } else if (status == 'endLoading'){
                this.isLoading = false
            } else if (status == 'isLoading'){
                this.isLoading = true
            }
        },
        initViewFromRoute(route) {
            this.$store.dispatch('actLoadEstabelecimentos')
            this.$store.dispatch('actLoadPlantasAbate')
            this.cdLoteProducao = parseInt(route.params.idLote)
            if (route.params.id){
                this.changeViewState('isEditing', route.params.id)
            } else {
                this.changeViewState('isInserting', null)
            }
        },
        getRegistro (id) {
            this.$axios.get('saida-animais/' + id)
            .then((response) => {
                var rec = response.data[0].data

                this.registro = Object.assign({}, rec)
                this.dataSaida = this.dateIsoToLocal(rec.dtSaida)
                this.dataAbate = this.dateIsoToLocal(rec.dtAbate)
                this.dataGTA = this.dateIsoToLocal(rec.dtGta)

                this.qtMachos = this.registro.qtMachos
                this.qtFemeas = this.registro.qtFemeas
                this.qtAnimais = this.registro.qtAnimais

                this.changeDestino(rec.csTipoDestino)
                this.changeViewState('endLoading')
                this.loadLoteProducao(this.registro.cdLoteProducao)
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        saveRegistro() {
            this.$v.$touch();
            if (this.$v.$invalid) return;
            if(!this.$refs.form.validate()) return;

            if(this.qtMachos > 0) this.registro.qtMachos = this.qtMachos
            else delete this.registro.qtMachos

            if(this.qtFemeas > 0) this.registro.qtFemeas = this.qtFemeas
            else delete this.registro.qtFemeas

            this.registro.qtAnimais = this.qtMachos + this.qtFemeas > 0 ? this.qtMachos + this.qtFemeas : this.qtAnimais

            this.registro.dtAbate = this.dataAbate !== '' ? this.dateLocalToIso(this.dataAbate) : null
            this.registro.hrSaida = this.registro.hrSaida + ':00'
            this.registro.dtGta = this.dateLocalToIso(this.dataGTA)
            this.registro.dtSaida = this.dateLocalToIso(this.dataSaida)

            if (this.isEditing)
            {
                this.updateRegistro()
            }
            else
            {
                this.insertRegistro()
            }

        },
        insertRegistro () {
            this.changeViewState('isLoading')

            this.$axios.post('saida-animais/', this.registro)
            .then(() => {
                this.$router.go(-1)
                this.$store.commit('setSnack', {type: 'success', msg: MensagemSuccessSave})
                this.changeViewState('endLoading')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        updateRegistro() {
            this.changeViewState('isLoading')

            this.$axios.put('saida-animais/' + this.registro.idSaidaAnimais, this.registro)
            .then(() => {
                this.$store.commit('setSnack', {type: 'success', msg: MensagemSuccessSave})
                this.changeViewState('endLoading')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        beforeDeleteRegistro() {
            this.$root.$confirm('Deseja Excluir?', 'O registro será excluído permanentemente.', { color: 'red', width: 400 })
            .then(confirm => {
                if (confirm)
                    this.deleteRegistro()
            })
        },
        deleteRegistro() {
            this.changeViewState('isLoading')
            this.$axios.delete('saida-animais/' + this.registro.idSaidaAnimais)
            .then(() => {
                this.$router.go(-1)
                this.changeViewState('endLoading')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        carregarRegistrosLimpos() {
            this.registro = {
                idSaidaAnimais: '',
                cdPessoaProdutor: 0,
                dtSaida: null,
                hrSaida: null,
                qtAnimais: 0,
                qtMachos: 0,
                qtFemeas: 0,
                dsPlacaCaminhao: '',
                csTipoDestino: '',
                nrGta: '',
                dsSerieGta: '',
                dtGta: null,
                cdEstabelecimentoDestino: null,
                cdUnidadeExploracaoDestino: null,
                cdPlantaAbate: null,
                cdLoteProducao: this.cdLoteProducao,
                dtAbate: null
            }
            this.loadLoteProducao(this.cdLoteProducao)
        },
        voltar() {
            this.$router.go(-1)
        }
    },
    watch: {
        '$route' (to) {
            this.initViewFromRoute(to)
        },
        'registro.cdEstabelecimentoDestino' (value) {
            if (!this.isLoading)
            {
                if (value != undefined)
                {
                    var context = this
                    this.$axios.get(this.urlAPIEstabelecimento + 'unidadeExploracao/?cdEstabelecimento=' + value)
                        .then((response) => {
                            var unidadesExploracao = response.data ? response.data.filter(entry => entry.stAtivo).map(toUepsView) : []
                            context.unidadesExploracao = unidadesExploracao
                        })
                        .catch((error) => {
                            this.changeViewState('isError', error)
                        })
                }
                else
                {
                    this.unidadesExploracao = []
                }
            }
        },
    },
    mounted() {
        this.initViewFromRoute(this.$route)
    },
}
</script>

<style scoped>
    .item {
        margin: 1px
    }
    .marginTitle {
        margin: 15px;
    }
    .headerCard {
        color: white; 
        background: #04222D; 
        padding:10px;
    }
</style>
